import React from 'react';

import TableDisplay from './TableDisplay';

import {Data} from '../services/data-manager';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';
import { notifyDanger, notifySuccess } from '../utils';
import Notification from 'react-notify-toast';
import { droitsAcces, modesPaiementMobile, pays } from '../config/globales';
import ReactToPrint from 'react-to-print';

class Partenaires extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            partenaires: [],
            partenaire: null,
            page: 1,
            nbPartenaire: 1,
            sizePartenaire: 50,
            showDetail: false,
            showPartenaire: false,
            showNewPartenaire: false,
            newPartenaire: {
                entreprise: "",
                nui: "",
                contribuable: null,
                banque: "",
                agenceBanque: "",
                numeroCompteBancaire: "",
                pays: "",
                ville: "",
                bp: "",
                tauxApprovisionnement: 0,
                tauxRetrait: 0,
                dateContrat: "",
                dateCreation: (new Date().getFullYear())+"-"+new Date().getMonth()+"-"+(new Date().getDate())+" "+(new Date().getHours())+":"+(new Date().getMinutes())+":"+(new Date().getSeconds()),
                hasApprovisionnement: 1,
                hasRetrait: 1
            },
            saveType: "add",
            recherche: {
                motCle: "",
                tri: ""
            },
            enTraitement: false,
            actions: []
        };
        this.getPartenaires = this.getPartenaires.bind(this);
        this.getDetailPartenaire = this.getDetailPartenaire.bind(this);
        this.handleInputNewPartenaire = this.handleInputNewPartenaire.bind(this);
        this.saveNewPartenaire = this.saveNewPartenaire.bind(this);
        this.showDetailModal = this.showDetailModal.bind(this);
        this.showNewPartenaireModal = this.showNewPartenaireModal.bind(this);
        this.handleRechercheForm = this.handleRechercheForm.bind(this);
        this.handleInputRecherche = this.handleInputRecherche.bind(this);
        this.openModifyPartenaire = this.openModifyPartenaire.bind(this);
        this.resetNewPartenaire = this.resetNewPartenaire.bind(this);
    }
    componentDidMount() {
        this.props.isLoading(true);
        this.getPartenaires();
        let actions = [];
        if ((this.props.auth.utilisateur.type>=40 && this.props.auth.utilisateur.type<50)) {
            actions.push({caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailPartenaire});
        }
        if (this.props.auth.utilisateur.type>=50) {
            actions.push({caption: <i className='fa fa-list'></i>, className:"btn btn-sm btn-primary mr-1", onClick:this.getDetailPartenaire});
            actions.push({caption: <i className='fa fa-pencil'></i>, className:"btn btn-sm btn-primary", onClick:this.openModifyPartenaire});
        }
        this.setState({actions: actions});
    }
    getPartenaires(page=0) {
        if (page!==0) {
            this.setState({page: page});
        } else {
            page = this.state.page;
        }
        this.props.isLoading(true);
        let sCondition = "1";
        let sOrder = "dateCreation DESC";
        if (this.state.recherche.tri!="") {
            sOrder = this.state.recherche.tri;
        }
        // Condition de recherche
        if (this.state.recherche.motCle!="") {
            let motCle = this.state.recherche.motCle;
            motCle = motCle.toUpperCase();
            const tMotCle = motCle.replace(/'|,/g, " ").split(" ");
            let sAddCondition = "";
            for(const mot of tMotCle) {
                sAddCondition += ` AND (UPPER(entreprise) LIKE "%${mot}%" OR (UPPER(nui) LIKE "%${mot}%" OR (UPPER(banque) LIKE "%${mot}%" OR (UPPER(agenceBanque) LIKE "%${mot}%" OR (UPPER(numeroCompteBancaire) LIKE "%${mot}%" OR UPPER(ville) LIKE "%${mot}%" OR UPPER(pays)="${mot}" OR UPPER(bp)="${motCle}")`;
            }
            sCondition += sAddCondition;
        }
        new Data()
        .get("Partenaire", sCondition, "agents", sOrder, page, this.state.sizePartenaire)
        .then(res => {
            this.setState({partenaires: res.rows, nbPartenaire: res.count});
            this.props.isLoading(false);
        })
        .catch(err => {
            console.warn("Error : ", err);
            this.props.isLoading(false);
        });
        window.scrollTo(0,0);
    }

    getDetailPartenaire(partenaire) {
        this.setState({partenaire: partenaire}, () => {
            this.showDetailModal();
        });
    }

    handleInputNewPartenaire(event) {
        let target = event.target;
        const name = target.name;
        let value = target.value;
        if (target.type=="checkbox") {
            value = target.checked ? 1 : 0;
        }
        let newPartenaire = this.state.newPartenaire;
        newPartenaire[name] = value;
        if (name=="pays") {
            let paysChoisi = pays.filter(p => (p.name==value));
            if (paysChoisi.length>0) newPartenaire.devise = paysChoisi[0].devise;
        }
        this.setState({newPartenaire: newPartenaire});
    }

    handleInputRecherche(event) {
        let target = event.target;
        const name = target.name;
        const value = target.value;
        let recherche = this.state.recherche;
        recherche[name] = value;
        this.setState({recherche: recherche});
    }
    
    saveNewPartenaire(event) {
        event.preventDefault();
        this.setState({enTraitement: true});
        let saveProcess;
        if (this.state.saveType=="modif") {
            saveProcess = new Data().update("Partenaire", this.state.newPartenaire,`id="${this.state.partenaire.id}"`);
        } else {
            saveProcess = new Data().add("Partenaire", this.state.newPartenaire);
        }
        saveProcess.then(res => {
            this.showNewPartenaireModal(false);
            notifySuccess("Partenaire enregistré !");
            this.getPartenaires(this.state.page);
            this.resetNewPartenaire();
        })
        .catch(err => {
            notifyDanger("Erreur lors de l'enregistrement de l'partenaire.");
        })
        .finally( () => {
            this.setState({enTraitement: false});
        });
    }

    openModifyPartenaire(partenaire) {
        this.setState({partenaire: partenaire, newPartenaire: partenaire, saveType: "modif"});
        this.showNewPartenaireModal(true);
    }

    resetNewPartenaire() {
        this.setState({
            newPartenaire: {
                entreprise: "",
                nui: "",
                contribuable: null,
                banque: "",
                agenceBanque: "",
                numeroCompteBancaire: "",
                pays: "",
                ville: "",
                bp: "",
                tauxApprovisionnement: 0,
                tauxRetrait: 0,
                dateContrat: "",
                dateCreation: (new Date().getFullYear())+"-"+new Date().getMonth()+"-"+(new Date().getDate())+" "+(new Date().getHours())+":"+(new Date().getMinutes())+":"+(new Date().getSeconds()),
                hasApprovisionnement: 1,
                hasRetrait: 1
            },
            saveType: "add"
        })
    }

    showDetailModal(show=true) {
        this.setState({showDetail: show});
    }
    showNewPartenaireModal(show=true) {
        this.setState({showNewPartenaire: show});
    }
    cancelPartenaire(partenaire) {
        window.confirm("Voulez vous vraiment supprimer la partenaire "+partenaire.id);
    }

    handleRechercheForm(event) {
        event.preventDefault();
        this.getPartenaires(this.state.page);
    }

    render() {
        return (
            <div className="container-fluid">
                <Notification options={{top: "100px"}} />
                <div className="row">
                    <div className="col-sm-12 my-3">
                        <div className="border p-3">
                            <form className="row" onSubmit={this.handleRechercheForm}>
                                <div className="col-6 col-md-6">
                                    <input className="form-control" name="motCle" placeholder="Recherche (entreprise, pays, banque, ...)" value={this.state.recherche.motCle} onChange={this.handleInputRecherche} />
                                </div>
                                <div className="col-4 col-sm-5 col-md-4">
                                    <select className="form-control" name="tri" value={this.state.recherche.motCle} onChange={this.handleInputRecherche}>
                                        <option value="">Ordre de tri</option>
                                        <option value="entreprise ASC">Ordre croissant de entreprise</option>
                                        <option value="entreprise DESC">Ordre décroissant de entreprise</option>
                                        <option value="dateCreation ASC">Ordre croissant de date d'inscription</option>
                                        <option value="dateCreation DESC">Ordre décroissant de date d'inscription</option>
                                    </select>
                                </div>
                                <div className="col-2 col-sm-1 col-md-2">
                                    <button className="btn btn-secondary btn-block" type="submit">
                                        <span className="d-none d-md-inline">Rechercher</span>
                                        <span className="d-inline d-md-none">...</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="row" ref={(myRef) => {this.printableToPDF = myRef}}>
                    <div className="col-sm-12 col-md-8 my-3">
                        <h3>
                            Partenaires
                            [Page {this.state.page}/{(this.state.nbPartenaire===0)?1:Math.ceil(this.state.nbPartenaire/this.state.sizePartenaire)}]
                        </h3>
                        {
                            (this.state.recherche.motCle!="") &&
                            <h5>
                                Filtre : 
                                {(this.state.recherche.motCle!="")?<span> {this.state.recherche.motCle.toUpperCase()}, </span>:""}
                            </h5>
                        }
                    </div>
                    <div className="col-sm-12 col-md-4 text-right my-0 my-md-3">
                        <ReactToPrint 
                            filename="africpay-transactions.pdf"
                            content={() => this.printableToPDF}
                            trigger={() => <button className="btn btn-secondary">Imprimer</button>}
                        />
                        <button type="button" className="btn btn-primary ml-1" onClick={() => {this.showNewPartenaireModal(true)}}>Ajouter un {(this.props.isClients)?"client":"partenaire"}</button>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <TableDisplay 
                            tableStriped={true}
                            tableHover={true}
                            thead="dark"
                            titles={["ID", "ENTREPRISE", "NUI", "PAYS", "VILLE", "DATE ENREGISTREE"]}
                            indices={["id", "entreprise", "nui", "pays", "ville", "dateCreation"]}
                            data={this.state.partenaires}
                            actions={this.state.actions}
                            withPaging={true}
                            pagingTheme="primary"
                            nb={this.state.nbPartenaire}
                            size={this.state.sizePartenaire}
                            current={this.state.page}
                            onChangePage= {this.getPartenaires}
                            withFooter={true} />
                    </div>
                </div>
                {(this.state.partenaire) &&
                <Modal show={this.state.showDetail} onHide={() => {this.showDetailModal(false)}} className="mt-4">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Détails du partenaire #{this.state.partenaire.id}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="mx-3">
                            <table className="table table-sm">
                                <tbody>
                                    <tr className="row">
                                        <td className="col-sm-5">ID : </td>
                                        <td className="col-sm-7">{this.state.partenaire.id}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Entreprise : </td>
                                        <td className="col-sm-7">{this.state.partenaire.entreprise}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">NUI : </td>
                                        <td className="col-sm-7">{this.state.partenaire.nui}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Pays : </td>
                                        <td className="col-sm-7">{this.state.partenaire.pays}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Ville : </td>
                                        <td className="col-sm-7">{this.state.partenaire.ville}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">B.P. : </td>
                                        <td className="col-sm-7">{this.state.partenaire.bp}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Banque : </td>
                                        <td className="col-sm-7">{this.state.partenaire.banque}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Agence banque : </td>
                                        <td className="col-sm-7">{this.state.partenaire.agenceBanque}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Numéro de compte bancaire : </td>
                                        <td className="col-sm-7">{this.state.partenaire.numeroCompteBancaire}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-9">Peut effectuer des approvisionnements ? : </td>
                                        <td className="col-sm-3">{(this.state.partenaire.hasApprovisionnement)?<span className="bg-success px-3 py-1">Oui</span>:<span className="bg-danger px-3 py-1">Non</span>}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Taux d'approvisionnement : </td>
                                        <td className="col-sm-7">{this.state.partenaire.tauxApprovisionnement}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-9">Peut effectuer des retrait ? : </td>
                                        <td className="col-sm-3">{(this.state.partenaire.actif==1)?<span className="bg-success px-3 py-1">Oui</span>:<span className="bg-danger px-3 py-1">Non</span>}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Taux de retrait : </td>
                                        <td className="col-sm-7">{this.state.partenaire.tauxRetrait}</td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date de contrat : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY">{this.state.partenaire.dateContrat}</Moment></td>
                                    </tr>
                                    <tr className="row">
                                        <td className="col-sm-5">Date d'enregistrement : </td>
                                        <td className="col-sm-7"><Moment format="DD/MM/YYYY à HH:mm">{this.state.partenaire.dateCreation}</Moment></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showDetailModal(false)}}>Fermer</button>
                    </Modal.Footer>
                </Modal>
                }
                <Modal show={this.state.showNewPartenaire} onHide={() => {this.showNewPartenaireModal(false)}} className="">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {(this.props.isClients)?"Nouveau client":"Nouvel partenaire"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="form-group col-md-12">
                                <label>Entreprise</label>
                                <input className="form-control" type="text" name="entreprise" placeholder="Entreprise" value={this.state.newPartenaire.entreprise} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>NUI</label>
                                <input className="form-control" type="text" name="nui" placeholder="NUI" value={this.state.newPartenaire.nui} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Pays</label>
                                <select className="form-control" name="pays" value={this.state.newPartenaire.pays} onChange={this.handleInputNewPartenaire} required>
                                    <option></option>
                                    {( pays.map((p, index) => <option value={ p.name } key={'pays-'+index}>{ p.name }</option> ) )}
                                </select>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Ville</label>
                                <input className="form-control" type="text" name="ville" placeholder="Ville" value={this.state.newPartenaire.ville} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>BP</label>
                                <input className="form-control" type="text" name="bp" placeholder="BP" value={this.state.newPartenaire.bp} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Banque</label>
                                <input className="form-control" type="text" name="banque" placeholder="Banque" value={this.state.newPartenaire.banque} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Agence de banque</label>
                                <input className="form-control" type="text" name="agenceBanque" placeholder="Agence de banque" value={this.state.newPartenaire.agenceBanque} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <label>Numéro compte bancaire</label>
                                <input className="form-control" type="text" name="numeroCompteBancaire" placeholder="Numéro compte bancaire" value={this.state.newPartenaire.numeroCompteBancaire} onChange={this.handleInputNewPartenaire} required />
                            </div>
                            <div className="form-group col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" id="hasApprovisionnement" name="hasApprovisionnement" checked={this.state.newPartenaire.hasApprovisionnement} onChange={this.handleInputNewPartenaire} />
                                    <label className="custom-control-label" htmlFor="hasApprovisionnement">Les agents du partenaire peuvent effectuer un approvisionnement.</label>
                                </div>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Taux approvisionnement</label>
                                <input className="form-control" type="number" name="tauxApprovisionnement" placeholder="Taux approvisionnement" value={this.state.newPartenaire.tauxApprovisionnement} onChange={this.handleInputNewPartenaire} />
                            </div>
                            <div className="form-group col-md-12">
                                <div className="custom-control custom-checkbox">
                                    <input type="checkbox" className="custom-control-input" id="hasRetrait" name="hasRetrait" checked={this.state.newPartenaire.hasRetrait} onChange={this.handleInputNewPartenaire} />
                                    <label className="custom-control-label" htmlFor="hasRetrait">Les agents du partenaire peuvent effectuer un retrait.</label>
                                </div>
                            </div>
                            <div className="form-group col-md-12">
                                <label>Taux de retrait</label>
                                <input className="form-control" type="number" name="tauxRetrait" placeholder="Taux de retrait" value={this.state.newPartenaire.tauxRetrait} onChange={this.handleInputNewPartenaire} required />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-secondary" onClick={() => {this.showNewPartenaireModal(false)}}>Fermer</button>
                        <button className="btn btn-primary" disabled={this.state.enTraitement} onClick={(e) => {this.saveNewPartenaire(e)}}>{(!this.state.enTraitement)?"Enregistrer":"Traitement..."}</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Partenaires;